import React, { useRef, useEffect } from 'react'
import Tickets from './Tickets'
import moment from 'moment-timezone';
const App = () => {
    
    return (
        <div>
            <Tickets />
        </div>
    )
}

export default App